<template>
    <div>
        <WidgetsDropdown :payable="payable" :sales="salesQty" :buys="purchaseQty" :products="productQty" :customers="customerQty"
        />
    </div>
</template>

<script>
import MainSaleChart from '../dashboard/MainSaleChart'
import barChart from "../panel/dashboardCharts/barChart";
import DonatChart from "../panel/dashboardCharts/DonatChart";
import WidgetsDropdown from '../widgets/WidgetsDropdown'
import WidgetsBrand from '../widgets/WidgetsBrand'
import {bus} from "../../main";
import axios from "axios";
    export default {
        name: 'Dashboard',
        components: {
            MainSaleChart,
            barChart,
            DonatChart,
            WidgetsDropdown,
            WidgetsBrand
        },
        data() {
            return {
                selected_tab: 1,
                selected: 'Month',
                system_report: [],
                productQty: '',
                selected_chart: 1,
                salesQty: '',
                payable: '',
                customerQty: '',
                purchaseQty: '',
                chartInfos: [],
                qtyInfos: [],
                sale_qty: [],
                sale_amount: [],
                sale_products: [],
                sale_category: [],
                buy_qty: [],
                buy_amount: [],
                buy_products: [],
                buy_category: [],
                sale_chart_report: {},
                sale_customers_qty_report: [],
                sale_customers_amount_report: [],
                buy_customers_qty_report: [],
                buy_customers_amount_report: [],
                profit_loss_bar: [],
                profit_loss_donat: [],
                cash_delivery_amount: [],
                cash_delivery_amount_percent: [],
                cash_delivery_qty: [],
                cash_delivery_qty_percent: [],

            }
        },
        computed: {
            donat_data_set() {
                return [
                    {label: 'sale', count: '90', color: '#3399ff'},
                    {label: 'revenue', count: '32', color: '#E46651'},
                    {label: 'purchase', count: '65', color: '#00D8FF'},
                    {label: 'customers', count: '85', color: '#DD1B16'},
                ]
            }
        },
        mounted() {
            bus.$on('dashboard_chart_selected', (data) => {
                // alert(data);
                this.selected_chart = data;
            });
            // bus.$emit("show_spinner", 'false');
            this.get_dashboard_data();
            // this.get_sale_data(1);
            // this.get_sale_data(3);
            // this.get_sale_amount(1);
            // this.get_sale_amount(3);
            // this.get_sale_items_data(3);
            // this.get_sale_items_data(1);
            //
            // this.get_sale_category_data(3);
            // this.get_sale_category_data(1);
            //
            // this.get_customers_qty_report(1);
            // this.get_customers_qty_report(3);
            //
            // this.get_customers_amount_report(1);
            // this.get_customers_amount_report(3);
            //
            // this.profit_loss_report();
            // this.get_sale_cash_delivery(3);


        },
        methods: {
            get_dashboard_data() {
                var self = this;

                const formData = new FormData();

                axios.post('GetSystemReport', formData, {}).then(function (response) {


                    self.productQty = response.data.data.productQty.toString()
                    self.customerQty = response.data.data.customerQty.toString()
                    self.salesQty = response.data.data.salesQty.toString()
                    self.purchaseQty = response.data.data.purchaseQty.toString()
                    self.payable = response.data.data.payable.toString()
                    // self.payable = "1000"
                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },

        },
    }
</script>
<style>
    .bg-revenue .nav-link.active {
        background: #3399FF;
        color: white;
    }

    .bg-sale .nav-link.active {
        background: #f9b115;
        color: white;
    }

    .bg-profit .nav-link.active {
        background: #2eb85c;
        color: white;
    }
</style>
